import { SimpleCommissionsTableContainer } from "components/Tables/SimpleCommissionsTable/SimpleCommissionsTableContainer.tsx";
import { AddButton } from "components/UI/Table/UI/AddButton/AddButton.tsx";
import { ColumnVisibility } from "components/UI/Table/UI/ColumnVisibility/ColumnVisibility.tsx";
import { ExpandButton } from "components/UI/Table/UI/ExpandButton/ExpandButton.tsx";
import { usePermission } from "hooks/usePermissions.ts";
import { FC, RefObject } from "react";
import { PermissionEnum } from "types/enums";
import { DrawerId, TableId } from "types/models";

interface CommissionsSectionProps {
    offer: App.Data.OfferData | undefined;
    expandButtonRef: RefObject<() => void>;
    scrollY?: number | string;
}

export const CommissionsSectionActions: FC<{ expandButtonRef: RefObject<() => void> }> = ({ expandButtonRef }) => {
    const permissionsUtils = usePermission();

    return (
        <div className="flex gap-2">
            <ColumnVisibility tableId={TableId.CommissionsTable} />
            <ExpandButton expandButtonRef={expandButtonRef} />
            {permissionsUtils.hasPermission(PermissionEnum.CommissionCreate) && (
                <AddButton drawerId={DrawerId.AddCommission}  />
            )}
        </div>
    );
};

export const CommissionsSection: FC<CommissionsSectionProps> = ({ offer, expandButtonRef, scrollY }) => {
    return (
        <SimpleCommissionsTableContainer
            offer={offer}
            editPermission={PermissionEnum.CommissionUpdate}
            expandButtonRef={expandButtonRef}
            scrollY={scrollY}
        />
    );
};
